<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Edit Letter Message </h5>
      <form [formGroup]="EditMailMessage" (submit)="SubmitEditMailMessage()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Title</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">Enter the title.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Text</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">Enter the text.</small>
          </div>
        </div>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!EditMailMessage.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
          <button routerLink="/MailMessage" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

